<template>
  <footer
    component-name="app-footer"
    class="flex justify-between items-center gap-lg py-md px-edge bg-skin-base text-skin-base"
  >
    <div data-lag="0.1" class="flex gap-lg items-center">
      <btn-primary
        :use-icon="false"
        :action="{ href_blank: `/${$route.params.locale}/cookie-policy` }"
        :title="$t.cookie_policy"
        size="small"
      />
      <btn-primary
        :use-icon="false"
        :action="{ href_blank: `/${$route.params.locale}/privacy-policy` }"
        :title="$t.privacy_policy"
        size="small"
      />
    </div>

    <div data-lag="0.2">
      <ClientOnly>
        <menu-language />
      </ClientOnly>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
html[data-footer-use-border=""] footer[component-name="app-footer"],
html[data-footer-use-border="true"] footer[component-name="app-footer"] {
  @apply border-t border-skin-inverted;
}
</style>
